module.exports = __webpack_public_path__ + "static/img/noOrder_Icon.ab85333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noOrder_Icon.png
// module id = cEty
// module chunks = 1